import * as React from "react";
import Note from "../../../model/note/Note";
import {Option} from "ts-option";
import {OnFailure, OnSuccess, OnSuccessData} from "../../../store/action/actionHelpers";
import {connect} from "react-redux";
import {addReminder, createNote, updateNote} from "../../../store/action/note/notes";
import {Dispatch} from "redux";
import Toast from "../../helper/Toast";
import {IMentionData} from "react-mentions";
import {api} from "../../../api/api";
import ReminderTab from "../../activityTabs/ReminderTab";
import moment = require("moment");
import _ = require("underscore");

interface IProps {
	/**
	 * Lead id for which form is created.
	 */
	leadId: string;
	/**
	 * Note to edit.
	 */
	noteToEdit?: Option<Note>;
	/**
	 * On note edit success
	 */
	onEditSuccess?: () => void;
}

interface DispatchProps {
	/**
	 * Add note action.
	 * @param {string} leadId lead identifier for which add note.
	 * @param {string} content note text.
	 * @param {string} extendedContent note extended text.
	 * @param {OnSuccessData<Note>} onSuccess on successful action callback.
	 * @param {OnFailure} onFailure on failure action callback.
	 */
	addNote: (leadId: string,
		content: string,
		extendedContent: string,
		onSuccess: OnSuccessData<Note>,
		onFailure: OnFailure) => void
	/**
	 * Set reminder for a note.
	 * @param {string} leadId lead identifier.
	 * @param {string} noteId note identifier.
	 * @param {moment.Moment} reminder reminder date.
	 * @param {OnSuccess} onSuccess on successful action callback.
	 * @param {OnFailure} onFailure on failure action callback.
	 */
	setReminder: (leadId: string, noteId: string, reminder: moment.Moment, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Update note action
	 * @param {string} noteId note identifier.
	 * @param {string} leadId lead identifier.
	 * @param {string} content note content to set.
	 * @param {string} extendedContent note extended text.
	 * @param {OnSuccessData<Note>} onSuccess on successful update action callback.
	 * @param {OnFailure} onFailure on failure update action callback.
	 */
	updateNote: (noteId: string,
		leadId: string,
		content: string,
		extendedContent: string,
		onSuccess: OnSuccess,
		onFailure: OnFailure) => void
}

type Props = IProps & DispatchProps

interface IState {
	/**
	 * Indicating if request to server is in progress.
	 */
	isLoading: boolean;
}

class LeadReminderTab extends React.Component<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {
			isLoading: false
		};
		this.onSubmit = this.onSubmit.bind(this);
		this.onFailure = this.onFailure.bind(this);
		this.mentionUsers = this.mentionUsers.bind(this);
	}

	render() {
		return (
			<ReminderTab isLoading={this.state.isLoading} onSubmit={this.onSubmit} noteToEdit={this.props.noteToEdit}/>
		);
	}


	private onSubmit(content: string,
		extendedContent: string,
		reminder: moment.Moment,
		mentions: IMentionData[],
		onNoteCreateEditSuccess: OnSuccess,
		onMentionSuccess: OnSuccess) {
		this.setState({isLoading: true});
		if (this.props.noteToEdit.isDefined) {
			const note = this.props.noteToEdit.get;
			this.props.updateNote(note.id, this.props.leadId, content, extendedContent, () => {
				this.props.setReminder(this.props.leadId, note.id, reminder,
					() => { this.setState({isLoading: false}, () => {onNoteCreateEditSuccess()}); },
					this.onFailure);
				this.props.onEditSuccess();
				Toast.success("Reminder edited successfully", "Edit Reminder");
				this.mentionUsers(mentions, onMentionSuccess, note.id);
			}, this.onFailure)
		}
		else {
			this.props.addNote(this.props.leadId, content, extendedContent, (note) => {
					this.props.setReminder(this.props.leadId, note.id, reminder,
						() => { this.setState({isLoading: false}, () => onNoteCreateEditSuccess()); },
						this.onFailure);
					Toast.success("Reminder added successfully.", "Create Reminder");
					this.mentionUsers(mentions, onMentionSuccess, note.id);
				},
				this.onFailure
			);
		}
	}

	private mentionUsers(mentions: IMentionData[], onMentionSuccess: OnSuccess, noteId: string) {
		const uniqueUsers = _.uniq(mentions.map(m => m.id));
		if (uniqueUsers.length)
			api.instance.leadApi.mentionUsers(this.props.leadId, uniqueUsers, noteId).then(onMentionSuccess).catch(
				() => Toast.error("Mention users error"));
	}

	/**
	 * Adding new reminder failure callback.
	 */
	private onFailure() {
		this.setState({isLoading: false});
		Toast.error("Sorry, something went wrong. Try again later.", "Create Reminder error");
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		addNote: (leadId: string,
			content: string,
			extendedContent: string,
			onSuccess: OnSuccessData<Note>,
			onFailure: OnFailure) =>
			dispatch(createNote(leadId, content, extendedContent, false, onSuccess, onFailure)),
		setReminder: (leadId: string, noteId: string, reminder: moment.Moment, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(addReminder(noteId, leadId, reminder, onSuccess, onFailure)),
		updateNote: (noteId: string, leadId: string, content: string, extendedContent: string, onSuccess: OnSuccess,
			onFailure: OnFailure) => dispatch(updateNote(noteId, leadId, content, extendedContent, onSuccess, onFailure))
	}
}

export default connect(null, mapDispatchToProps)(LeadReminderTab)